import(/* webpackMode: "eager", webpackExports: ["PartnerLink"] */ "/vercel/path0/apps/esa/src/app/content/partner/partner-link.tsx");
